import { render, staticRenderFns } from "./PaymentSupplementsform.vue?vue&type=template&id=21aa33f2&scoped=true"
import script from "./PaymentSupplementsform.vue?vue&type=script&lang=js"
export * from "./PaymentSupplementsform.vue?vue&type=script&lang=js"
import style0 from "./PaymentSupplementsform.vue?vue&type=style&index=0&id=21aa33f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21aa33f2",
  null
  
)

export default component.exports